import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import React from 'react'
import { Link } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { Avatar, Typography } from '@material-ui/core'
import Slider from 'react-slick'

import { UserContext } from '../../App'
import { SUGGEST_USERS } from '../../graphql/queries'
import { LoadingLargeIcon } from '../../icons'
import { useFollowSuggestionsStyles } from '../../styles'
import FollowButton from './FollowButton'

function FollowSuggestions({ hideHeader }) {
  const classes = useFollowSuggestionsStyles()
  const { followerIds, me } = React.useContext(UserContext)
  const variables = { limit: 20, followerIds, createdAt: me.created_at }
  const { data, loading } = useQuery(SUGGEST_USERS, { variables })

  return (
    <div className={classes.container}>
      {!hideHeader && (
        <Typography
          variant="subtitle2"
          color="textSecondary"
          className={classes.typography}
        >
          Suggestions for You
        </Typography>
      )}
      {loading ? (
        <LoadingLargeIcon />
      ) : (
        <Slider
          className={classes.slide}
          dots={false}
          infinite={false}
          speed={1000}
          touchThreshold={1000}
          variableWidth
          swipeToSlide
          arrows
          slidesToScroll={3}
          easing="ease-in-out"
        >
          {data.users.map(user => (
            <FollowSuggestionsItem key={user.id} user={user} />
          ))}
        </Slider>
      )}
    </div>
  )
}

function FollowSuggestionsItem({ user }) {
  const classes = useFollowSuggestionsStyles()
  const { profile_image, username, name, id } = user

  return (
    <div className={classes.card}>
      <Link to={`/${username}`}>
        <Avatar
          src={profile_image}
          alt={`${username}'s profile`}
          classes={{ root: classes.avatar, img: classes.avatarImg }}
        />
      </Link>
      <Link to={`/${username}`}>
        <Typography variant="subtitle2" className={classes.text} align="center">
          {username}
        </Typography>
      </Link>
      <Typography
        color="textSecondary"
        variant="body2"
        className={classes.text}
        align="center"
      >
        {name}
      </Typography>
      <FollowButton id={id} side={false} />
    </div>
  )
}

export default FollowSuggestions
